<template>
    <div class="BasicProject clearfix">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm" :inline="true">
                <p class="form_title">
                    <span>
                        基本信息：
                    </span>
                </p>
                <div class="declare_form_one clearfix">
                    <el-col
                        :xl="{span:6}"
                        :lg="{span:8}"
                        :md="{span:12}">
                        <el-form-item label="项目编号" prop="name" style="width:100%">
                            <el-input v-model="ruleForm.name" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col
                        :xl="{span:6}"
                        :lg="{span:8}"
                        :md="{span:12}">
                        <el-form-item label="项目名称" prop="name" style="width:100%">
                            <el-input v-model="ruleForm.name" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col 
                        :xl="{span:6}"
                        :lg="{span:8}"
                        :md="{span:12}">
                        <el-form-item label="项目类型" prop="type" style="width:100%">
                            <el-input v-model="ruleForm.name" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col 
                        :xl="{span:6}"
                        :lg="{span:8}"
                        :md="{span:12}">
                        <el-form-item label="项目级别" prop="type" style="width:100%">
                            <el-input v-model="ruleForm.name" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col 
                        :xl="{span:6}"
                        :lg="{span:8}"
                        :md="{span:12}">
                        <el-form-item label="项目负责人" prop="type" style="width:100%">
                            <el-input v-model="ruleForm.name" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col 
                        :xl="{span:6}"
                        :lg="{span:8}"
                        :md="{span:12}">
                        <el-form-item label="项目开始时间" prop="declarationTime" style="width:100%">
                            <el-date-picker
                                v-model="ruleForm.declarationTime"
                                value-format="yyyy-MM-dd"
                                type="date"
                                disabled>
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col 
                        :xl="{span:6}"
                        :lg="{span:8}"
                        :md="{span:12}">
                        <el-form-item label="项目结束时间" prop="declarationTime" style="width:100%">
                            <el-date-picker
                                v-model="ruleForm.declarationTime"
                                value-format="yyyy-MM-dd"
                                type="date"
                                disabled>
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col 
                        :xl="{span:6}"
                        :lg="{span:8}"
                        :md="{span:12}">
                        <el-form-item label="填表时间" prop="declarationTime" style="width:100%">
                            <el-date-picker
                                v-model="ruleForm.declarationTime"
                                value-format="yyyy-MM-dd"
                                type="date"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </div>
            </el-form>
            <p class="form_title fl">
                <span>
                    团队成员：
                </span>
            </p>
            <div class="teammem fl">
                <el-table 
                    :data="tableData" 
                    style="width: 100%;min-height:150px"
                    stripe
                    :cell-style="{'text-align':'center'}"
                    :header-cell-style="{background:'#fafafa',color:'rgba(0,0,0,.85)','text-align':'center'}"
                >   
                    <el-table-column prop="name" label="姓名"></el-table-column>
                    <el-table-column prop="date" label="年级"></el-table-column>
                    <el-table-column prop="name" label="学校"></el-table-column>
                    <el-table-column prop="date" label="所在院系/专业"></el-table-column>
                    <el-table-column prop="date" label="联系电话"></el-table-column>
                    <el-table-column prop="date" label="E-mail"></el-table-column>
                </el-table>
            </div>
            <p class="form_title fl">
                <span>
                    指导教师：
                </span>
            </p>
            <div class="teammem fl">
                <el-table 
                    :data="teachList" 
                    style="width: 100%;min-height:150px"
                    stripe
                    :cell-style="{'text-align':'center'}"
                    :header-cell-style="{background:'#fafafa',color:'rgba(0,0,0,.85)','text-align':'center'}"
                >   
                    <el-table-column type="index" label="序号" width="55"></el-table-column>
                    <el-table-column prop="name" label="姓名"></el-table-column>
                    <el-table-column prop="age" label="年龄"></el-table-column>
                    <el-table-column prop="phone" label="联系电话"></el-table-column>
                    <el-table-column prop="researchOrientation" label="研究方向"></el-table-column>
                    <el-table-column prop="executivePosition" label="行政职务/专业技术职务"></el-table-column>
                    <el-table-column prop="outcome" label="主要成果"></el-table-column>
                </el-table>
            </div>
            <div class="next_step fl">
                <el-button type="primary" @click="newtion('ruleForm')">下一步</el-button>
            </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            tableData:[],
            ruleForm:{},
            rules:{},
            teachList:[],
        }
    },
    methods: {
        newtion(){
            this.$router.push('/SummaryReport')
        },
    },
    mounted() {
        
    },
}
</script>
<style scoped>
@import './../../assets/css/student/Postprojectreport.css';
</style>
<style>
.BasicProject .el-date-editor.el-input{
    width:100%;
}
.BasicProject .declare_form_one .el-form-item__content{
    width: calc(100% - 120px);
}
</style>